<form autocomplete="off" id="filterForm" #filterForm="ngForm">
  <div class="modal-wrapper">
    <div class="overlay" *ngIf="spinnerVisible$ | async">
      <app-spinner></app-spinner>
    </div>
    <div class="add-filter-header modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ titleText }}</h4>

      <div>
        <button type="button" class="close" aria-label="Close" (click)="cancell()">
          <span aria-hidden="true">&times;</span>
        </button>
        <span class="resize" role="button" tabindex="0" aria-label="full screen" (click)="resize()" title="Toggle full width mode">
          <i class="material-icons" *ngIf="!isFullScreen"> fullscreen </i>
          <i class="material-icons" *ngIf="isFullScreen"> fullscreen_exit </i>
        </span>
      </div>
    </div>
    <div class="modal-header modal-secondary-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 align-self-center">Select filter type</div>
          <div class="col-6 align-self-center">
            <div>
              <span class="ey-float-label">
                <select
                  class="form-control form-select"
                  id="filter-type"
                  name="filterType"
                  [(ngModel)]="filterType"
                  (change)="filterTypeChanged()"
                  [disabled]="disableFilterType"
                  appLabelFloat
                >
                  <option *ngIf="!filterType" [value]="undefined" disabled selected></option>
                  <option *ngFor="let type of studyFilters" [ngValue]="type">{{ type.displayText }}</option>
                </select>
                <label for="filter-type">Select Filter Type</label>
              </span>
            </div>
            <span class="help-block" *ngIf="isMultiDBSelect && isStatusFilterSelected">This is Compustat DB's only dedicated filter.</span>
          </div>
        </div>
        <div class="row">
          <div class="row mt-3" *ngIf="message?.length > 0">
            <div class="col-12">
              <ngb-alert *ngIf="message?.length > 0" (close)="message = ''" [type]="type">{{ message }}</ngb-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body ey-add-filter-body">
      <div class="container-fluid">
        <div class="row" [ngClass]="{ 'filter-grid': !filterType && filterType?.lookupId !== 0 }">
          <div class="col-12 align-self-center text-center empty-filter-grid" *ngIf="!filterType && filterType?.lookupId !== 0; else filterGrid">
            <span>No filter has been selected</span>
          </div>
          <ng-template #filterGrid>
            <div class="col-12 align-self-center category-of-companies-container">
              <ng-container *ngTemplateOutlet="filterCriteria"></ng-container>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="modal-footer ey-add-filter-footer">
      <button type="button" class="btn btn-default" (click)="cancell()">Cancel</button>
      <button
        type="button"
        (click)="addFilter(true)"
        *ngIf="btnAddContdFilterText && !searchFilter"
        class="btn btn-primary"
        [disabled]="disableAddFilterButton(filterForm)"
      >
        {{ btnAddContdFilterText }}
      </button>
      <button
        type="button"
        (click)="addFilter(false)"
        *ngIf="btnAddCloseFilterText"
        class="btn btn-primary"
        [disabled]="disableAddFilterButton(filterForm)"
      >
        {{ btnAddCloseFilterText }}
      </button>
    </div>
  </div>
  <!-- Parent template for Filter Criteria -->
  <ng-template #filterCriteria>
    <div class="row filter-type-header">
      <div class="col-6">
        {{ filter.title }}
      </div>
    </div>
    <div *ngIf="filterType.name === filterTypes.CategoryOfCompany">
      <app-filter-category-of-company [readOnly]="readOnly" [filter]="filter" [submitClicked]="submitClicked"></app-filter-category-of-company>
    </div>
    <div *ngIf="filterType.name === filterTypes.IdentificationNumber">
      <app-filter-identification-number [readOnly]="readOnly" [filter]="filter"></app-filter-identification-number>
    </div>
    <div *ngIf="filterType.name === filterTypes.YearOfIncorporation">
      <app-filter-year-of-incorporation [readOnly]="readOnly" [filter]="filter"></app-filter-year-of-incorporation>
    </div>
    <div *ngIf="filterType.name === filterTypes.Website">
      <app-filter-website [readOnly]="readOnly" [filter]="filter" [submitClicked]="submitClicked"></app-filter-website>
    </div>
    <div *ngIf="filterType.name === filterTypes.Status">
      <app-filter-status [readOnly]="readOnly" [filter]="filter" [submitClicked]="submitClicked"></app-filter-status>
    </div>
    <div *ngIf="filterType.name === filterTypes.Location">
      <app-filter-location [readOnly]="readOnly" [filter]="filter" [submitClicked]="submitClicked"></app-filter-location>
    </div>
    <div *ngIf="filterType.name === filterTypes.LegalForm">
      <app-filter-legal-form [readOnly]="readOnly" [filter]="filter" [submitClicked]="submitClicked"></app-filter-legal-form>
    </div>
    <div *ngIf="filterType.name === filterTypes.AccountType">
      <app-filter-account-types [readOnly]="readOnly" [filter]="filter"></app-filter-account-types>
    </div>
    <div *ngIf="filterType.name === filterTypes.NumberOfEmployees">
      <app-filter-number-of-employees [readOnly]="readOnly" [filter]="filter"></app-filter-number-of-employees>
    </div>
    <div *ngIf="filterType.name === filterTypes.IndustryClassifications">
      <app-filter-industry-classifications
        [readOnly]="readOnly"
        [filter]="filter"
        [submitClicked]="submitClicked"
      ></app-filter-industry-classifications>
    </div>
    <div *ngIf="filterType.name === filterTypes.BVDIndependenceIndicator">
      <app-filter-bvdindependence-indicator [readOnly]="readOnly" [filter]="filter"></app-filter-bvdindependence-indicator>
    </div>
    <div *ngIf="filterType.name === filterTypes.ShareholderCharacteristics">
      <app-filter-shareholder-characteristics
        [readOnly]="readOnly"
        [filter]="filter"
        [submitClicked]="submitClicked"
      ></app-filter-shareholder-characteristics>
    </div>
    <div *ngIf="filterType.name === filterTypes.SubsidiaryCharacteristics">
      <app-filter-subsidiary-characteristics [readOnly]="readOnly" [filter]="filter"></app-filter-subsidiary-characteristics>
    </div>
    <div *ngIf="filterType.name === filterTypes.Financial">
      <app-filter-financial [submitClicked]="submitClicked" [readOnly]="readOnly" [filter]="filter"></app-filter-financial>
    </div>
    <div *ngIf="filterType.name === filterTypes.CompanyName">
      <app-filter-company-name [readOnly]="readOnly" [filter]="filter"></app-filter-company-name>
    </div>
    <div *ngIf="filterType.name === filterTypes.Keywords">
      <app-filter-keywords [readOnly]="readOnly" [filter]="filter"></app-filter-keywords>
    </div>
    <div *ngIf="filterType.name === filterTypes.ListedUnlisted">
      <app-filter-listed-unlisted [readOnly]="readOnly" [filter]="filter"></app-filter-listed-unlisted>
    </div>
  </ng-template>
</form>
